export interface AppConfig {
  apiBaseUrl: string
  remoteStorageUrl: string
  stage?: 'devel' | 'staging' | 'uat' | 'production'
  debug: boolean
  version: string
  features: Record<string, boolean>
}

export class ConfigManager {
  private static config: Partial<AppConfig> = {}

  static initialize(config: Partial<AppConfig>): void {
    this.config = { ...this.config, ...config }
  }

  /** Reset config to empty state (for testing) */
  static reset(): void {
    this.config = {}
  }

  static get<K extends keyof AppConfig>(key: K): AppConfig[K] | undefined {
    return this.config[key]
  }

  static getRequired<K extends keyof AppConfig>(key: K): AppConfig[K] {
    const value = this.config[key]
    if (value === undefined) throw new Error(`Required config key "${key}" is not defined`)
    return value
  }

  static set<K extends keyof AppConfig>(key: K, value: AppConfig[K]): void { this.config[key] = value }
  static getAll(): Partial<AppConfig> { return { ...this.config } }
  static isDebug(): boolean { return this.config.debug ?? getEnv('NODE_ENV') === 'development' }
}

function getEnv(key: string, defaultValue: string = ''): string {
  if (typeof process !== 'undefined' && process.env) return process.env[key] || defaultValue
  return defaultValue
}

export const defaultConfig: Partial<AppConfig> = {
  debug: getEnv('NODE_ENV') === 'development',
  apiBaseUrl: getEnv('REACT_APP_API_BASE_URL', 'https://tradovateapi.com'),
  remoteStorageUrl: getEnv('REACT_APP_REMOTE_STORAGE_URL', 'https://config.tradovateapi.com/'),
  version: getEnv('REACT_APP_VERSION', '1.0.0'),
  features: {}
}

